import React from 'react'
import { Input } from 'antd'

export interface ConstructionYearInputProps {
  value?: string
  onChange?: (value: string) => void
  disabled?: boolean
  className?: string
  style?: React.CSSProperties
  placeholder?: string
}

export default function ConstructionYearInput({
  value = '',
  onChange = undefined,
  disabled = false,
  className = undefined,
  style = undefined,
  placeholder = '例：1985'
}: ConstructionYearInputProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const rawVal = e.target.value
    const sanitized = rawVal.replace(/[^0-9]/g, '').slice(0, 4)
    onChange?.(sanitized)
  }

  return (
    <Input
      value={value}
      placeholder={placeholder}
      maxLength={4}
      disabled={disabled}
      onChange={handleChange}
      className={className}
      style={{
        width: 110,
        height: 38,
        fontSize: 14,
        color: '#021120',
        ...style
      }}
    />
  )
}

ConstructionYearInput.defaultProps = {
  value: '',
  onChange: undefined,
  disabled: false,
  className: undefined,
  style: undefined,
  placeholder: '例：1985'
}
